import { derived, type Readable } from 'svelte/store';
import { user } from './stores/auth';

/**
 * Bridge between the user's persisted `unit_system` setting and the
 * `formatDistance` helper in @atlasguess/games. The user store stores
 * `'miles' | 'kilometers' | undefined`; formatDistance expects the
 * shorter `'miles' | 'km'` slug. We translate here so neither side has
 * to know about the other's vocabulary.
 *
 * Defaults to `'miles'` when no user is signed in or no preference is
 * set, matching the historical default that was hardcoded across mode
 * configs before this store existed.
 *
 * Use as `$displayUnit` in a Svelte component — derived from the user
 * store, so changing the setting in /account immediately re-renders
 * any distance label currently on screen.
 */
export const displayUnit: Readable<'miles' | 'km'> = derived(user, ($user) => {
  return $user?.settings?.unit_system === 'kilometers' ? 'km' : 'miles';
});
